"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ADMIN_BASE_URL = process.env.REACT_APP_ADMIN_URL;
/**
 * @param route Start route with a '/'
 * @returns
 */

exports.generateAdminBaseUrl = function (route) {
  return ADMIN_BASE_URL + route;
};